
import React, { useState } from 'react';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { GetGuest, OpenGate, CloseGate } from '../../store/actions/gateActions'; 
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import 'firebase/firestore';
import '../../Guest.css';
import ReactCodeInput from "react-code-input";
import superagent from "superagent";

const GuestPass = props => {
    const version = "0.48";
    var key = window.localStorage.getItem( "key" );
    var haveKey = key !== null ? false : true;

    const [ openDialog, setOpenDialog ]     = useState(false);
    const [ isBlinking, setBlink ]          = useState(false);
    const [ isVerifying, setVerify ]        = useState(false);
    const [ sendingSMS, setSendingSMS ]     = useState(false);
    const [ needCode, setCode ]             = useState(haveKey);
    const [ smsCodeInput, setVerifyCode ]   = useState(true);
    const [ resentModal, setResentModal ]   = useState(false);
    const [ dialogLoading, setDLoading ]    = useState(false);
    const [ gateWas, setGateStatus ]        = useState(props.gate.status);
    const isLoading  = props.isLoading;
    const gate_id    = props.match.params.gate;
    const user_id    = props.match.params.key;
    const gateData   = props.gate;
    const guest      = props.guest;
    const expireTime = guest.expireTime;
    const startTime  = guest.startTime;
    const serverTime = new Date(props.date).getTime();
    const isExpired  = serverTime > expireTime ? true : props.isExpired ? true : false
    const isReady    = serverTime > startTime  ? true : false

    if( isLoading === true ) {
      props.GetGuest(gate_id, user_id);
    }

    if( gateWas !== gateData.status ) {
      setGateStatus(gateData.status);
    }

    if( isBlinking === true 
      && gateWas !== gateData.status ) {
      setBlink(false);
    }
    
    //Deny Dialogue
    if( openDialog === false ) {
        if( typeof gateData !== "undefined" && typeof guest !== "undefined" ) {
          if( typeof gateData.deny !== "undefined" ) {
          if( gateData.deny.includes(guest.phone) ) {
            setOpenDialog(true);
          }
        }
      }
    }

    const getGuest = async () => {
      //Check Key;
      props.GetGuest(gate_id, user_id);
    }

    const verifyGuest = async () => {
      setVerify(true);
      const code = parseInt(smsCodeInput);
      if( code > 1000 ) {
        let response = await superagent.post(`https://us-central1-maximum-controls-app.cloudfunctions.net/functionsGatesGuestVerify`).send({ gate: gate_id, guest: user_id, code: code });
        let result = response.body;
        if( result && result.error ) {
          setVerify(false);
          switch(result.message) {
            case "time_expired": alert("SMS Code Expired. Please resend a new one."); break;
            case "invalid_code": alert("SMS Code Invalid."); break;
            case "request_hour": alert("Too many attempts. Please try in again in about 1 hour."); break;
            case "no_code": alert("There are no code to verify. Please resend a new one."); break;
          }
        } else if( result.success ) {
          window.localStorage.setItem( "key", result.key );
          setCode(false);
        }
      } else {
        alert("Code must be Numeric");
      }
      setVerify(false);
    }

    const sendSMS = async () => {
      setSendingSMS(true);
      await superagent.post(`https://us-central1-maximum-controls-app.cloudfunctions.net/functionsGatesGuestLogin`).send({ gate: gate_id, guest: user_id});
      setTimeout(() => {
        setSendingSMS(false);
        setResentModal(true);
      }, 1000);
    }

    const closeDialog = async () => {
      if( !dialogLoading ) {
        setDLoading(true);
        await superagent.get(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/confirm/deny/${gate_id}/${user_id}`);
        setTimeout(() => {
          setOpenDialog(false);
          setTimeout(() => { setDLoading(false); }, 1000 );
        }, 2000);
      }
    };

    if( (isLoading === true && isExpired === false) || 
        (isExpired === false && isReady === false ) || (needCode) ) {
      return (
        <div className="Guest">
          <header>
            <div className="logo"><img src="/logo.png" alt="Max Control Logo" height="50" /></div>
          </header>
          {needCode && isExpired === false && isLoading === false &&
            <div>
              <div>Welcome Guest!</div>
              <div>Please verify SMS Code to access gate</div>
              <div style={{ padding: "15px" }}>
                <ReactCodeInput 
                  inputStyle={{ 
                    fontFamily: "monospace",
                    appearance: "textfield",
                    borderRadius: "6px",
                    border: "1px solid lightgrey",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
                    margin: "4px",
                    paddingLeft: "8px",
                    width: "36px",
                    height: "42px",
                    fontSize: "20px",
                    boxSizing: "border-box",
                    color: "black",
                    backgroundColor: "white"
                  }}
                  onChange={e => setVerifyCode(e)} 
                  type='number' 
                  fields={4} 
                />
              </div>
              <div>
                { sendingSMS ? <CircularProgress size={15} /> : <button style={{ padding: "5px 15px", minHeight: "40px", background: "#8ec760" }} type="button" onClick={sendSMS}>Request Code</button>}
              </div> 
              <div style={{marginTop: "15px"}}>
                { isVerifying ? <CircularProgress size={25} /> : <button style={{ padding: "5px", minHeight: "40px", background: "#4a88ca" }} type="button" onClick={verifyGuest}>Verify</button>}
              </div>
            </div>
          }
          {isLoading === true && isExpired === false && 
            <div style={{fontSize: "1.5em", fontWeight: "bold"}}>Loading...</div>
          }
          {isExpired === true && 
            <div style={{fontSize: "1.5em", fontWeight: "bold"}}>This pass has expired.</div>
          }
          {isExpired === false && isReady === false && isLoading == false && !needCode && 
            <div style={{fontSize: "1.5em", fontWeight: "bold"}}>This pass is not ready.</div>
          }
          <Dialog
            open={resentModal}
            onClose={() => setResentModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">SMS Code Resent</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                A code has been resent to the Phone Number of this pass. 
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setResentModal(false)} color="primary" autoFocus>Okay</Button>
            </DialogActions>
          </Dialog>
          <footer>Max Cloud App &copy; {new Date().getFullYear()} - Version {version}</footer>
        </div>
      );
    }
  
    let openClass  = "open";
    let closeClass = "close";
    switch(gateData.status) {
      case "stopped": openClass = "open";     closeClass = "close"; break;
      case "erd1":
      case "erd2":
      case "status":  openClass = "disable";  closeClass = "disable"; break;
      case "open":
      case "opening": openClass = "disable";  closeClass = "close"; break;
      case "close": 
      case "closing": openClass = "open";     closeClass = "disabled"; break;
      default:        openClass = "open";     closeClass = "disabled";
    }
  
    let statusText = gateData.status;
    if( statusText === "close" )                    statusText = "Closed";
    if( statusText === "unsafeToClose" )            statusText = "Unsafe to Close";
    if( statusText === "unsafeToOpen" )             statusText = "Unsafe to Open";
    if( statusText === "gateTamper" )               statusText = "Tampered";
    if( statusText === "ulSensorFail" )             statusText = "Sensor Failed";
    if( typeof gateData.released !== "undefined" )  statusText = "Gate Released";

    let start  = new Date(guest.startTime);
    let expire = new Date(guest.expireTime);

    return (
      <div className="Guest">
        <header>
          <div className="logo"><img src="/logo.png" alt="Max Control Logo" height="50" /></div>
          {isLoading === false && isExpired === false &&
            <div className="gateDetail">
              <div style={{textAlign: "left"}}>{gateData.name}</div>
              <div style={{textAlign: "right"}}>Guest</div>
            </div>
          }
        </header>
        {isExpired === true && 
            <div style={{fontSize: "1.5em", fontWeight: "bold"}}>This pass has expired.</div>
        }
        {isLoading === false && isExpired === false && isReady === true &&
          <div>
            <div className="gateTitle">{gateData.name}</div>
            <button className={openClass} onClick={async () => {
              if( gateData.status == "open" || 
                gateData.status == "opening" || 
                gateData.status == "unsafeToOpen" || 
                gateData.status == "unsafeToClose" || 
                gateData.isReleasedManually || 
                gateData.status == "erd2"  ) return;
              if( 
                gateData.status !== "open" ||
                gateData.status !== "opening" ||
                gateData.status !== "erd1" ||
                gateData.status !== "erd2" ||
                gateData.status !== "unsafeToClose" ||
                gateData.status !== "unsafeToOpen" ||
                typeof gateData.released !== "undefined" 
              ) {
                setBlink(true);
                setTimeout(() => setBlink(false), 5000);
                props.OpenGate(gate_id, user_id);
              }            
            }}>OPEN</button>
            <div className={isBlinking ? "status blink" : "status"}>
              CURRENT STATUS: {statusText}
            </div>
            {(gateData.autoCloseTimer === 0 || typeof gateData.autoCloseTimer === "undefined") &&
              <button className={closeClass} onClick={async () => {
                if( gateData.status == "closed" || 
                  gateData.status == "closing" || 
                  gateData.status == "close" || 
                  gateData.status == "unsafeToOpen" || 
                  gateData.status == "unsafeToClose" || 
                  gateData.isReleasedManually || 
                  gateData.status == "erd2"  ) return;
                if( 
                  gateData.status !== "closed" ||
                  gateData.status !== "closing" ||
                  gateData.status !== "erd1" ||
                  gateData.status !== "erd2" ||
                  gateData.status !== "unsafeToClose" ||
                  gateData.status !== "unsafeToOpen" ||
                  typeof gateData.released !== "undefined" 
                ) {
                  setBlink(true);
                  setTimeout(() => setBlink(false), 5000);
                  props.CloseGate(gate_id, user_id);
                }
              }}>CLOSE</button>
            }
          </div>
        }
        <Dialog
          open={openDialog}
          onClose={closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Access Denied</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Outside of access period
            </DialogContentText>
          </DialogContent>
          <DialogActions>
              {dialogLoading ? <CircularProgress size={30} /> : <Button onClick={closeDialog} color="primary" autoFocus>Okay</Button> }
          </DialogActions>
        </Dialog>
        <footer>
          {/* <div>My Start Time: {guest.startTime} | {new Date(guest.startTime).toUTCString()} | Adjusted: {start.toLocaleString()}</div>
          <div>My Expire Time: {guest.expireTime} | {new Date(guest.expireTime).toUTCString()} | Adjusted: {expire.toLocaleString()}</div>
          <div>Server Time: {serverTime} | {new Date(serverTime).toUTCString()}</div> */}
          Max Cloud App &copy; {new Date().getFullYear()} - Version {version}
        </footer>
      </div>
    );
}

const mapStateToProps = (state) => {
  return {
      gate:       state.guest.gate,
      guest:      state.guest.guest,
      isExpired:  state.guest.isExpired,
      isLoading:  state.guest.isLoading,
      date:       state.guest.date
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      GetGuest:       (gate_id, key) => dispatch(   GetGuest(gate_id, key)),
      OpenGate:       (gate_id, key) => dispatch(   OpenGate(gate_id, key)),
      CloseGate:      (gate_id, key) => dispatch(  CloseGate(gate_id, key)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestPass);

  